import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal, ModalHeader, Spinner } from 'reactstrap';

import { UPDATE_GAME_STATUS, UPDATE_GAME_STATUS_EMPTY } from '../../../../../../../store/actions';

const UpdateModal = ({ onClose, currentGameDetails, updateType }) => {
  const dispatch = useDispatch();

  /* ---------------------------- REDUX STATES ---------------------------- */
  const { updateGameStatus, updateGameStatusLoading } = useSelector((state: any) => ({
    updateGameStatus: state?.UpdateGameStatus?.data,
    updateGameStatusLoading: state?.UpdateGameStatus?.loading,
  }));

  const handleSubmit = () => {
    dispatch({
      type: UPDATE_GAME_STATUS,
      payload: {
        data: {
          game_id: currentGameDetails?.game_id,
          game_name: currentGameDetails?.game_name,
          type: currentGameDetails?.game_type,
          status: updateType,
        },
        type: currentGameDetails?.game_type,
      },
    });
  };

  useEffect(() => {
    if (updateGameStatus !== null) {
      dispatch({
        type: UPDATE_GAME_STATUS_EMPTY,
      });
      onClose();
    }

    return () => {
      dispatch({
        type: UPDATE_GAME_STATUS_EMPTY,
      });
    };
  }, [updateGameStatus]);

  return (
    <Modal isOpen={true} centered size="md">
      <ModalHeader toggle={onClose}></ModalHeader>
      <h4 style={{ textAlign: 'center', padding: '18px 40px' }}>Are you sure you want to {updateType === 'expired' ? 'expire' : 'live'} the Quiz</h4>
      <div className="d-flex justify-content-center mb-4 gap-3">
        {!updateGameStatusLoading && (
          <Button color="primary" style={{ fontSize: '14px', width: '100px', borderRadius: '10px' }} onClick={handleSubmit}>
            Yes
          </Button>
        )}

        {updateGameStatusLoading && (
          <Button color="primary" style={{ fontSize: '14px', width: '100px', borderRadius: '10px' }}>
            <Spinner className="btn-replacer-spinner" />
          </Button>
        )}

        <Button color="white" style={{ fontSize: '14px', width: '100px', borderRadius: '10px', border: '1px solid #401589' }} onClick={onClose}>
          No
        </Button>
      </div>
    </Modal>
  );
};

export default UpdateModal;
